export default {
  portfolioSection: {
    authorImage: require('@/assets/img/author.jpg'),
    authorNameChinese: '曹 瑜璇',
    authorNameEnglish: 'Cao Yuxuan',
    quote: "Every journey begins in silence — but ends in self-transcendence.",
    brand: {
      acronym: "O.Y.I.M.",
      description: "Open Your Inner Mind (Unleash Your Creative Potential)"
    }
  },
  information: {
    title: "About Me",
    subtitle: "My Profile & Contact Info",
    profile: {
      image: require('@/assets/img/author.jpg'),
      name: "Cao Yuxuan",
      title: "Web Designer / Graphic Designer / Illustrator",
      contact: [
        {
          icon: "fas fa-envelope",
          text: "ouinemelles2@gmail.com",
          link: "ouinemelles2@gmail.com"
        },
        {
          icon: "fas fa-map-marker-alt",
          text: "Tokyo, Japan",
          link: "https://maps.google.com/?q=Tokyo,Japan"
        }
      ],
      social: [
        {
          icon: "fab fa-linkedin",
          link: "https://www.linkedin.com/in/yuzuha0427/",
          label: "LinkedIn"
        },
        {
          icon: "fab fa-instagram",
          link: "https://www.instagram.com/oyim_0427/",
          label: "Instagram"
        }
      ]
    },
    skills: [
      {
        category: "Web Development",
        icon: "fas fa-code",
        items: [
          {
            name: "HTML5 / CSS3",
            level: 95
          },
          {
            name: "JavaScript / jQuery",
            level: 90
          },
          {
            name: "Node.js / Vue.js",
            level: 75
          },
          {
            name: "SQL / Salesforce",
            level: 70
          }
        ]
      },
      {
        category: "Design Tools",
        icon: "fas fa-palette",
        items: [
          {
            name: "Photoshop",
            level: 100
          },
          {
            name: "Illustrator",
            level: 100
          },
          {
            name: "Premiere Pro",
            level: 80
          },
          {
            name: "After Effects",
            level: 70
          },
          {
            name: "Figma",
            level: 95
          },
          {
            name: "Clip Studio Paint",
            level: 100
          }
        ]
      },
      {
        category: "Languages",
        icon: "fas fa-language",
        items: [
          {
            name: "Japanese",
            level: 80,
            note: "Proficient"
          },
          {
            name: "English",
            level: 70,
            note: "Intermediate"
          },
          {
            name: "Chinese",
            level: 100,
            note: "Fluent"
          }
        ]
      }
    ],
    experience: [
      {
        period: "2023 - Present",
        title: "Web Developer & Web Designer / Graphic Designer",
        description: "Building responsive websites and web applications, while also creating visual assets and brand-consistent designs.",
        responsibilities: [
          "Developed and maintained responsive websites and web applications using relevant web technologies",
          "Designed user-friendly interfaces and implemented them into fully functional web pages",
          "Created a variety of marketing assets, including banners, social media graphics, and infographics",
          "Communicated with clients together with my leader to understand their needs and deliver customized web solutions"
        ]
      },
      {
        period: "2020 - 2023",
        title: "Web Designer / Graphic Designer & Illustrator",
        description: "Designed a variety of product visuals for various media across digital and print platforms.",
        responsibilities: [
          "Designed website layouts, UI components, and brand visual elements for a variety of clients",
          "Created custom illustrations for both web and print to enhance visual storytelling",
          "Collaborated closely with developers to build e-commerce websites with consistent cross-platform design",
          "Contributed to both online and offline advertising designs, including promotional images, banners, and posters"
        ]
      }
    ]
  }
};
